export const ACCESS_TOKEN_KEY = 'asi7yBUvjhKJ9ub';
export const CACHED_URL = 'CACHED_URL';
export const RECORD_START_TIME = 'RECORD_START_TIME';
export const RECORD_DURATION = 'RECORD_DURATION';
export const SHOW_SIDEBAR = 'SHOW_SIDEBAR';
